export default "__VITE_ASSET__DycEjYiV__"